import { HttpClient } from '@/shared/lib/http-client';

export const checkPayment = async (invoiceId) => {
  const response = await HttpClient.get('/payments/check-invoice', { invoice: invoiceId });

  return response.data;
};